
// Sidebar.jsx
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import sidebar from "../data/sidebar";
import { useTranslation } from 'react-i18next';
import { getJson } from '../services/http';

const Sidebar = ({ tenantId }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false); // ← collapsed by default
  const [expandedMenu, setExpandedMenu] = useState({});
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const navigate = useNavigate();

  // Check super-admin access once on mount
  useEffect(() => {
    getJson('/api/super-admin/check-access')
      .then(() => setIsSuperAdmin(true))
      .catch(() => {}); // silently fail for non-admin tenants
  }, []);

  const toggleSidebar = () => setIsOpen((v) => !v);
  const toggleSubmenu = (index) =>
    setExpandedMenu((prev) => ({ ...prev, [index]: !prev[index] }));

  // Keep existing logout behavior by navigating to /logout
  const handleLogout = () => {
    navigate("/logout");
  };

  return (
    <div className={`sidebar ${isOpen ? "open" : "collapsed"}`}>
      {/* Inner flex container so we can pin Logout to the bottom */}
      <div
        className="sidebar-inner"
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {/* Top section: toggle + regular menu groups */}
        <div>
          <div className="icon-div">
            {isOpen ? (
              <i
                className="bi bi-caret-left-fill"
                onClick={toggleSidebar}
              ></i>
            ) : (
              <i
                className="bi bi-caret-right-fill"
                onClick={toggleSidebar}
              ></i>
            )}
          </div>

          <ul className="menu-list">
            {sidebar(tenantId, { isSuperAdmin }).map((menuItem, index) => (
              <li key={index} className="menu-item">
                <div
                  className="menu-title"
                  onClick={() =>
                    menuItem.childrens && toggleSubmenu(index)
                  }
                  style={{
                    cursor: menuItem.childrens ? "pointer" : "default",
                  }}
                >
                  <i className={`bi ${menuItem.icon}`}></i>
                  <span className="menu-label">{menuItem.title}</span>
                  {menuItem.childrens && (
                    <i
                      className={`bi ${
                        expandedMenu[index]
                          ? "bi-chevron-down"
                          : "bi-chevron-right"
                      } submenu-toggle-icon`}
                      style={{ marginLeft: "auto" }}
                    />
                  )}
                </div>

                {menuItem.childrens && expandedMenu[index] && (
                  <ul className="submenu-list">
                    {menuItem.childrens.map((child, idx) => (
                      <li key={idx} className="submenu-item">
                        <Link
                          to={child.path}
                        >
                          <i className={`bi ${child.icon}`} />
                          <span className="menu-label">{child.title}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Bottom Logout icon as a top-level menu item */}
        <div
          className="logout-container"
          style={{
            marginTop: "auto",
            padding: "0.5rem 0",
            borderTop: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          <div className="menu-item">
            <div
              className="menu-title"
              onClick={handleLogout}
              style={{ cursor: "pointer" }}
            >
              <i className="bi bi-door-closed-fill"></i>
              <span className="menu-label">{t('auth.logoutText')}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
